import {Grid} from '@mui/material'
import React from 'react'
import MyContractsTest from '../payments/utilities/myContracts/myContractsNew/MyContractsTest';

export const Favorites = (props) => {

  return (
    <Grid container width={'100%'} justifyContent='center' pb={'5%'}>           
        <Grid item sx={{width:'89%', pt:'2%', '@media (max-width: 899px)':{width:'100%'}}}>
            <MyContractsTest utilityName={''} currentLocation='dashboard'  />
        </Grid>
    </Grid>
  )
}
export default Favorites